import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchCountries } from '@/renderer/services/accommodationService';

export function useCountries() {
  return useQuery({
    queryKey: queryKeys.accommodation.countries(),
    queryFn: async () => {
      const data = await fetchCountries();
      return data;
    },
    staleTime: 1000 * 60 * 60, // 1 hr — countries almost never change
  });
}
